import Section from "@/components/editorial/Section";
import Eyebrow from "@/components/editorial/Eyebrow";
import NewsletterForm from "@/components/editorial/NewsletterForm";
import { EDITORIAL_IMAGES } from "@/data/content";

export default function Community() {
  return (
    <Section tone="cream" padding="xl" testid="community-section" id="community">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <Eyebrow tone="terracotta" className="mb-5">
            Comunidad
          </Eyebrow>
          <h2 className="font-serif font-light leading-[1.05] tracking-tight text-[clamp(2.25rem,4.5vw,4rem)] text-charcoal">
            Únete a la red de<br />
            <span className="italic">mujeres que están<br />moviendo México.</span>
          </h2>
          <div className="mt-7 space-y-4 text-[17px] leading-relaxed text-charcoal/80 max-w-xl">
            <p>
              Un espacio seguro y activo: mentorías cruzadas, encuentros
              mensuales presenciales, directorio privado de mujeres líderes, y
              acceso anticipado a nuevas historias y eventos.
            </p>
            <p className="text-charcoal/60 italic">
              App privada de comunidad · próximamente 2026.
            </p>
          </div>

          <div className="mt-10 max-w-lg">
            <NewsletterForm
              variant="community"
              tone="light"
              testidPrefix="community"
              endpoint="/submissions/community"
            />
          </div>
        </div>

        <div className="lg:col-span-5 order-1 lg:order-2">
          <div className="relative aspect-[3/4] overflow-hidden rounded-sm">
            <img
              src={EDITORIAL_IMAGES.community}
              alt="Encuentro de comunidad Mujeres Motor"
              loading="lazy"
              decoding="async"
              width="1024"
              height="1536"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-charcoal/5" />
          </div>
        </div>
      </div>
    </Section>
  );
}
